<!--
 * @FileDescription: 新增盘点选择条件（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-16（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
    <a-modal  class="inventory-model" v-model="isShowModel"   :title="title"   @cancel="onCancel" @ok="onCofrimForm">
        <a-form :form="form"
                :label-col="{ span: 9}"
                :wrapper-col="{ span: 12 }" >
            <a-form-item label="请选定盘点仓库" >
                <a-select  v-decorator="['checkStorageId',{ rules: [{ required: true,message:'请选定盘点仓库'}] },]"
                           placeholder="请选择仓库"
                >
                    <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                    <a-select-option v-for="item in storageList" :key="item.id">{{item.storageName}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="请选定盘点截止时间">
                <a-date-picker   v-decorator="['deadline', {rules: [{ type: 'object', required: true, message: '请选定盘点截止时间' }]}]"
                                 @change="changeDate"
                                 :disabled-date="disabledEndDate"
                                 placeholder="请选定盘点截止时间"/>
            </a-form-item>
        </a-form>
        <div class="inventory-explain">
            <img src="@/assets/image/tishi.png"/>
            说明：请在此截止时间以前完成盘点，否则就会过期
        </div>
    </a-modal>
    <a-modal  v-model="isShowModel1" class="import-model"  :title="title1"  :footer="null" :maskClosable="false">
        <div class="import-top">
            <div class="import-top-title">导入说明:</div>
            <div class="import-top-title1" v-if="index == 1">
                <span>1、首先需要下载盘点模版表格，盘点模版表格中<span style="color: #FF0000">商品编号和名称不能修改</span>;</span>
                <span>2、请在盘点截止时间以前完成盘点，否则就会过期；</span>
                <span>3、Excel中商品实际数量为空的将不做导入，视作未盘点，录入数字支持小数点后最多3位，录入数字则为已盘点；</span>
                <span>4、导入模版，可以直接在当前弹框中下载模版后，也可以在新增盘点页面导出盘点数据后编辑，在此处进行导入；</span>
                <span>5、匹配商品，以商品编号和商品名称两项进行匹配，匹配成功则导入；</span>
                <span> 6、导入excel文件大小最多支持4M，表格中最多20000行。</span>
            </div>
            <div class="import-top-title1" v-if="index == 2">
                <span>1、导入的商品数据内容需要按照系统提供的“模板”填写；</span>
                <span>2、不可修改模板格式，以确保数据的准确性；</span>
                <span>3、划重点，“商品名称”一定要填，否则导入失败；</span>
                <span>4、商品编号不能与系统中的编号重复</span>
                <span>5、文件仅支持xls、xlsx格式；</span>
                <span>6、文件大小不能超过4M，表格中最多有20000行数据。</span>
            </div>
        </div>
        <div class="import-top" style="padding-top: 25px">
            <a-timeline>
                <a-timeline-item>
                    <div slot="dot" class="import-cir">1</div>
                    <div class="import-content">
                        <div class="import-item-title">设定基本信息，下载模板文件</div>
                        <div class="import-xia" @click="handleExports1(1,'商品模板')" style="margin-top: 20px">
                            <img src="@/assets/image/xiazai3.png"/>
                            <span>下载模板</span>
                        </div>
                    </div>
                </a-timeline-item>
                <a-timeline-item>
                    <div slot="dot" class="import-cir">2</div>
                    <div class="import-content1">
                        <div class="import-item-title">导入文件<span style="color: #888888;font-size: 14px;font-weight: 400">（根据下载模版文件格式，填写您的库存信息再上传）</span></div>
                        <div class="import-select">
                            <div class="import-select-left">
                                <div class="import-select-input">{{filename}}</div>
                                <div class="import-select-wen">
                                    <input type="file" ref="thumbnail" id="input"  @change="handleImport"  />
                                    选择文件
                                </div>
                            </div>
                            <div class="import-select-right" v-if="visible">
                                <a-progress :percent="percent" :status="status" strokeColor="#F76F14"/>
                            </div>
                        </div>
                    </div>
                </a-timeline-item>
                <a-timeline-item>
                    <div slot="dot" class="import-cir">3</div>
                    <div class="import-content2">
                        <div class="import-item-title">导入结果和调整</div>
                        <template v-if="!isEmpty(result)">
                            <div class="import-result" v-if="result.success">
                                <img src="@/assets/image/chenggong(1).png"/>
                                <template v-if="index == 1">
                                    <span v-html="result.logMessage"></span>
                                </template>
                                <template v-if="index == 2">
                                    <span>导入完成，成功导入{{result.result.successRows}}条数据<span>,<span style="color:#FF0000 ">导入失败{{result.result.errorRows}}条数据</span></span></span>
                                </template>
                            </div>
                            <div class="import-result" v-if="!result.success">
                                <img src="@/assets/image/shibai(1).png"/>
                                <span style="color:#FF0000 ">当前文件格式错误，请检查文件或者下载最新的模板文件</span>
                            </div>
                            <div class="import-xia" v-if="result.result.errorRows != 0" @click="handleExports1(2,'错误商品报告')">
                                <span>下载错误报告</span>
                            </div>
                        </template>
                    </div>
                </a-timeline-item>
            </a-timeline>
        </div>
        <div class="import-btn">
            <a-button class="btn-cancel-disabled" :disabled="true" v-if="!visible1">关闭</a-button>
            <a-button type="primary" class="btn-save" v-if="visible1" @click="onCancel">关闭</a-button>
        </div>
    </a-modal>
  </div>
</template>
<script>
import {exportStock,importStock,exportStockwarn,productImport,productImportError,getImportantStatus} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from 'moment';
import pick from 'lodash.pick'
import ACol from "ant-design-vue/es/grid/Col";
import axios from 'axios'
export default {
    mixins:[mixins],
    data(){
        return{
            isShowModel:false,
            title:'选定库存盘点',
            form: this.$form.createForm(this),
            isShowModel1:false,
            title1:'批量导入',
            percent:0,
            status:'active',
            index:1,
            deadline:'',
            stockId:'',
            visible:false,
            visible1:false,
            result:'',
            filename:'未选择',
            formData:{},
            timer: null,
        }
    },
    watch: {

    },
    mounted () {
        this.storageListSelect()
    },
    created () {

    },
    components: {
        ACol,
        AFormItem


    },
    methods: {
        moment,
        /**
        * @description: 此为方法注释（方法描述）
        */
        onOpen(index,index1,id,item){
            if(index == 1){
                this.isShowModel = true
                this.form = this.$form.createForm(this)
                if(!this.isEmpty(localStorage.getItem("inventoryStorage"))){
                     setTimeout(() => {
                        this.form.setFieldsValue({
                            checkStorageId:localStorage.getItem("inventoryStorage")
                        })
                    }, 300);
                 }
            }else if(index == 2){
                this.isShowModel1 = true
                this.filename = '未选择'
                this.result = ''
                if(index1 == 2){
                    this.index = 2
                }else{
                    this.index = 1
                    this.stockId = id
                    this.formData = item
                }
            }
        },
        openother(){
            this.isShowModel1 = true
        },
        /**
         * @description: 时间（方法描述）
         */
        changeDate(date, dateString){
            this.deadline = dateString
        },
        onCancel(){
          this.isShowModel1 = false
            this.isShowModel = false
        },
        disabledEndDate(endValue){
            if (!endValue) {
                return false;
            }
            return endValue.valueOf() < moment(new Date().toLocaleDateString()).valueOf();
        },
        onCofrimForm(){
            this.form.validateFields((err, values) => {
                if(!err){
                    values.deadline = this.deadline
                    values.index = '1'
                    this.storageList.forEach((item)=>{
                        if(item.id == values.checkStorageId){
                            values.checkStorageName = item.storageName
                        }
                    })
                    localStorage.setItem('inventoryStorage',values.checkStorageId)
                    let arr = JSON.stringify(values)
                    this.$router.push('/librarymanage/warehousemanage/InventoryRecord?item='+encodeURIComponent(arr))
                    this.isShowModel = false
                }
            })
        },
        /**
         * @description: 导出 tab 1是模板  2是错误 index 1是盘点    2是商品（方法描述）
         */
        //
        handleExports1(tab,fileName){
            if(tab == 1){
                if(this.index == 1){
                    axios({
                        method:'post',
                        url:'/storage/api/checkStock/exportCheckStockById',
                        data:{},
                        params:{
                            companyStoreId:this.$store.state.shopId,
                            id:this.stockId
                        },
                        headers:{},
                        responseType: 'blob'
                    }).then((res)=>{
                        let url = window.URL.createObjectURL(new Blob([res.data],{type: "application/vnd.ms-excel"}))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download',  this.formData.checkStorageName+'库存盘点.xls')
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    })
                }else{
                    let url = 'https://kingcheer.oss-cn-hangzhou.aliyuncs.com/erp/system/product/product-import-template.xls'
                    var a = document.createElement('a')
                    a.style.display = 'none'
                    a.href = url
                    a.setAttribute('download', fileName + '.xls')
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                }
            }else{
                if(this.index == 1){
                    axios({
                        method:'post',
                        url:'/storage/api/checkStock/exportErrorCheckStockByKey',
                        data:{},
                        params:{
                            companyStoreId:this.$store.state.shopId,
                            key:this.result.result,
                        },
                        headers:{},
                        responseType: 'blob'
                    }).then((res)=>{
                        let url = window.URL.createObjectURL(new Blob([res.data],{type: "application/vnd.ms-excel"}))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', fileName + '.xls')
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    })
                }else{
                    axios({
                        method:'post',
                        url:'/product/api/productApi/exportErrorExcel',
                        data:{},
                        params:{
                            companyStoreId:this.$store.state.shopId,
                            key:this.result.result.key,
                        },
                        headers:{},
                        responseType: 'blob'
                    }).then((res)=>{
                        let url = window.URL.createObjectURL(new Blob([res.data],{type: "application/vnd.ms-excel"}))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', fileName + '.xls')
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    })
                }
            }

        },
        /**
         * @description: 导入（方法描述）
         */
        handleImport(){
            this.result = ''
            if(this.index == 1){
                let file = this.$refs.thumbnail.files[0]
                this.filename = file.name
                this.visible = true
                setTimeout(()=>{
                    this.percent = 50
                },100)
                var form = new FormData()
                form.append("companyStoreId",this.$store.state.shopId)
                form.append("file",file,file.name)
                form.append("id",this.stockId)
                importStock(form,{
                    'Content-Type':'multipart/form-data'
                }).then((res)=>{
                    $('#input').val('')
                    if(res.success){
                        this.result = res
                        this.$emit('onChangeFile',res.result)
                        this.percent = 100
                        this.visible1 = true
                        setTimeout(()=>{
                            this.visible = false
                            this.percent = 0
                        },100)
                    }else{
                        this.visible = true
                        this.$message.warn(res.logMessage)
                        this.result = res
                    }
                })
            }else{
                let file = this.$refs.thumbnail.files[0]
                this.filename = file.name
                this.visible = true
                setTimeout(()=>{
                    this.percent = 50
                },100)
                var form = new FormData()
                form.append("companyStoreId",this.$store.state.shopId)
                form.append("file",file)
                productImport(form,{
                    'Content-Type':'multipart/form-data'
                }).then((res)=>{
                    // if(res.success){
                    //     this.result = res
                    //     this.$emit('onChangeFile',res.result)
                    //     this.percent = 100
                    //     this.visible1 = true
                    //     setTimeout(()=>{
                    //         this.visible = false
                    //         this.percent = 0
                    //     },100)
                    // }else{
                    //     this.visible1 = true
                    //     this.$message.warn(res.logMessage)
                    //     this.result = res
                    // }
                })
                var dataobj = new FormData()
                dataobj.append("companyStoreId",this.$store.state.shopId)
                this.timer = setInterval(()=>{
                    getImportantStatus(dataobj,{}).then((res)=>{
                        if(res.success){
                            if( res.result.status == 1){
                                $('#input').val('')
                                clearInterval(this.timer)
                                this.timer = null
                                this.result = res
                                this.$emit('onChangeFile',res.result)
                                this.percent = 100
                                this.visible1 = true
                                setTimeout(()=>{
                                    this.visible = false
                                    this.percent = 0
                                },100)
                                if(!this.isShowModel1){
                                    this.$emit('onchangeother',res.result)
                                }
                            }
                        }else{
                            $('#input').val('')
                            clearInterval(this.timer)
                            this.timer = null
                            this.visible1 = true
                            this.$message.warn(res.logMessage)
                            this.result = res

                        }
                    })
                },1000)

            }
        }
    },

}
</script>
<style lang="scss">
    .import-model{
        width: 900px !important;
        height: 830px !important;
        z-index: 10000;
        .ant-modal-body{
            padding:24px 65px 24px 24px !important;
        }
        .ant-timeline-item-content{
            margin: 0 0 0 25px !important;
        }
    }
    .inventory-model{
        width: 550px !important;
        height: 380px !important;
    }
</style>
<style scoped lang="scss">
.inventory-explain{
    width:420px;
    height:38px;
    background:rgba(255,251,230,1);
    border:1px solid rgba(255,229,143,1);
    border-radius:4px;
    margin-left: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--co);
    img{
        width: 14px;
        margin-right: 8px;
    }
}
.import-model{
    .import-top{
        padding-left: 60px;
        .import-top-title{
            color: #333;
            font-weight: 700;
        }
        .import-top-title1{
            padding-top: 10px;
            display: flex;
            flex-direction: column;
            line-height: 24px;
        }
        .import-cir{
            width:24px;
            height:24px;
            background:rgba(247,111,20,1);
            border-radius:50%;
            color: #fff;
            font-size: 16px;
            font-weight: 700;
            text-align: center;
            line-height: 24px;
        }
        .import-content{
            height: 122px;
            background-color: #FAFAFA;
            padding: 24px 0 0 31px;
            border-radius: 10px;
        }
        .import-item-title{
            color: #333333;
            font-size: 14px;
            font-weight: 700;
        }
        .form-top{
            padding: 20px 0 10px;
            height: 80px;
        }
        .import-xia{
            cursor: pointer;
            width:120px;
            height:36px;
            background:rgba(255,255,255,1);
            border:1px solid rgba(56,123,252,1);
            border-radius:6px;
            color: #387BFC;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .import-content1{
            height: 125px;
            background-color: #FAFAFA;
            padding: 24px 0 0 31px;
        }
        .import-select{
            display: flex;
            align-items: center;
            margin-top: 26px;
            .import-select-left{
                width: 246px;
                height: 36px;
                line-height: 36px;
                border:1px solid rgba(230,230,230,1);
                border-radius:6px;
                display: flex;
                .import-select-input{
                    cursor: pointer;
                    width: 172px;
                    border-right: 1px solid #DDDDDD;
                    padding-left: 5px;
                    background-color: #fff;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    border-radius: 6px 0 0 6px;
                }
                .import-select-wen{
                    cursor: pointer;
                    text-align: center;
                    width: 74px;
                    position: relative;
                    input{
                       position: absolute;
                        top: 0;
                        left: 0;
                        width: 74px;
                        height: 36px;
                        opacity: 0;
                    }
                }
            }
            .import-select-right{
                margin-left: 20px;
                width: 250px;
            }
        }
        .import-content2{
            min-height:64px;
            background-color: #FAFAFA;
            padding: 24px 0 10px 31px;
            .import-result{
                padding: 25px 0 15px;
                color: #333333;
                img{
                    width: 18px;
                    margin-right: 5px;
                }
            }
        }
    }
    .import-btn{
        display: flex;
        align-items: center;
        justify-content: center;
    }


}
</style>
